export default [{
  path: '/portal',
  component: resolve => require(['@/components/oa/view/portal/main/main.vue'], resolve),//门户主界面
  children: [{
      path: '/',
      component: resolve => require(['@/components/oa/view/portal/home/home.vue'], resolve) //门户首页
  },{
    path: '/portal/contacts',
    component: resolve => require(['@/components/oa/view/portal/contacts/contacts.vue'], resolve) //通讯录
  },{
    path: '/portal/sendDoc',
    component: resolve => require(['@/components/oa/view/portal/sendDoc/list.vue'], resolve) //通讯录
  },{
    path: '/portal/search',
    component: resolve => require(['@/components/oa/view/portal/search/search.vue'], resolve) //搜索结果
  },{
    path: '/portal/news/:code/:name',
    component: resolve => require(['@/components/oa/view/portal/list/list.vue'], resolve) //新闻列表
  },{
    path: '/portal/news/info/:key/:name',
    component: resolve => require(['@/components/oa/view/portal/info/info.vue'], resolve) //新闻详情
  },{
    path: '/portal/mail',
    component: resolve => require(['@/components/oa/view/portal/mail/mail.vue'], resolve) //领导信箱
  }]
}]



// WEBPACK FOOTER //
// ./src/components/oa/router/portal.js